module.exports = __webpack_public_path__ + "img/copy.4c1f0c81.svg";